/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Form, Checkbox } from 'antd';

import { TermCard } from 'components';

const { Item } = Form;

const BadesulProofOfCivilStatus = ({ input, loading, selectedBusinessUser, business, sizeMap }) => (
  <Col {...sizeMap.large}>
    <TermCard
      type={selectedBusinessUser?.user?.civilStatus?.value}
      alert="A seguir, você assinará um termo que comprova a veracidade do estado civil do sócio. Leia atentamente."
      user={selectedBusinessUser?.user}
      business={business}
      address={selectedBusinessUser?.user?.address}
    />
    <Item
      name={input.value}
      valuePropName="checked"
      rules={[
        () => ({
          validator(_, value) {
            if (value) {
              return Promise.resolve();
            }
            return Promise.reject(new Error('Você precisa concordar com o termo'));
          },
        }),
      ]}
    >
      <Checkbox loading={loading}>{input.text}</Checkbox>
    </Item>
  </Col>
);

export default BadesulProofOfCivilStatus;
